import { Box, type BoxProps } from '@chakra-ui/react'
import { clsx } from 'clsx'

const MATERIAL_SYMBOLS_URL =
  'https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200&display=swap'

type GrandProseProps = BoxProps & { rawStyles?: boolean }

const defaultStyles = {
  '*+*': {
    mt: 5
  },
  '*+br': {
    mt: 0
  },

  'h1, h2, h3, h4': {
    fontFamily: 'heading',
    textAlign: 'left'
  },

  'h1, h2': {
    fontWeight: 'medium',
    lineHeight: 1.4,
    mb: 6
  },

  h1: {
    fontSize: {
      base: '185%',
      md: '225%'
    }
  },

  h2: {
    fontSize: '150%'
  },

  h3: {
    fontWeight: 'normal',
    fontSize: '125%',
    lineHeight: 1.4
  },

  h4: {
    fontWeight: 'normal',
    fontSize: '112.5%',
    lineHeight: 1.4
  },

  h5: {
    fontWeight: 'normal',
    fontSize: {
      base: '100%',
      md: '112.5%'
    },
    lineHeight: 1.9
  },

  p: {
    fontWeight: 400,
    fontSize: '100%',
    lineHeight: 1.9
  },

  'th, td': {
    border: '1px solid var(--chakra-colors-chakra-border-color)',
    py: 2,
    px: 3
  },

  ul: {
    listStyleType: 'disc',
    pl: '1.4em'
  },

  'ul, ul > li': {
    listStylePosition: 'outside'
  },
  'li+li': {
    mt: 2
  },
  'p+ul': {
    mt: 4
  },

  '*+h1, *+h2': {
    mt: 12
  },
  '*+h3, *+h4': {
    mt: 10
  },
  a: {
    color: 'primary'
  }
}

export const GrandProse = ({ children, sx, className, rawStyles, ...props }: GrandProseProps) => {
  return (
    <>
      <link rel="stylesheet" href={MATERIAL_SYMBOLS_URL} />
      <Box
        className={clsx('GrandProse', className)}
        sx={{
          ...(rawStyles ? {} : defaultStyles),
          ...sx
        }}
        {...props}
      >
        {children}
      </Box>
    </>
  )
}
